import { useLatestCallback } from 'hook/useLatestCallback'
import { createContext, ReactNode, useContext, useState } from 'react'

export type DropdownStore = {
  open: boolean
  setOpen(value: boolean): void
}

const Context = createContext<DropdownStore | undefined>(undefined)
const Provider = Context.Provider

type ConstuctorProps = {
  onOpen?: (open: boolean) => void
}

export function useDropdownConstructor({ onOpen }: ConstuctorProps): DropdownStore {
  const [open, setOpenRaw] = useState(false)

  const setOpen = useLatestCallback((open: boolean) => {
    setOpenRaw(open)
    if (onOpen) onOpen(open)
  })

  return { open, setOpen }
}

type ProviderProps = {
  children: ReactNode
  store: DropdownStore
}

export function DropdownProvider({ children, store }: ProviderProps) {
  return <Provider value={store}>
    {children}
  </Provider>
}

export function useDropdown(): DropdownStore {
  const context = useContext(Context)
  if (!context) throw new Error('no context')
  return context
}

export function useOptionalDropdown(): DropdownStore | undefined {
  return useContext(Context)
}
